import React from "react";
import { useNavigate } from "react-router-dom";

export const JumpIN = () => {
  const navigate = useNavigate();
  const handleOnClick = () => {
    navigate("/jumpin");
  };
  return (
    <div
      onClick={handleOnClick}
      className={`
              h-10 w-fit mx-auto bg-blue-600 
              hover:bg-white hover:border-4 hover:border-slate-600
              text-white hover:text-blue-600
            transition-all duration-300 rounded-full
            flex flex-row items-center justify-center
            px-4 cursor-pointer`}
    >
      <div className="flex-grow text-center">Jump In</div>
    </div>
  );
};
